export default {
    apiKey: "AIzaSyDO4Vi6MINqPD7ZhViDQJaNwEVP014iEJI",
    authDomain: "seo-2020-awards-dinner.firebaseapp.com",
    databaseURL: "https://seo-2020-awards-dinner.firebaseio.com",
    projectId: "seo-2020-awards-dinner",
    storageBucket: "seo-2020-awards-dinner.appspot.com",
    messagingSenderId: "56197961333",
    appId: "1:56197961333:web:0a7fc067cac64ef7e44a3c",
    measurementId: "G-44CTNK3YW2"
}
